// 英文译文 · 通用词 + 外壳(菜单 / 顶栏 / 登录)· key = 代码里的中文原文,一字不差
// 各页面自己的词放 ./<模块>.ts;这里的词各页面直接复用,别在别的文件里再译一遍
export default {
  // ── 外壳 ──
  "wms-erp · 跨境贸易 ERP": "wms-erp · Cross-border Trade ERP",
  "跨境贸易 ERP": "Cross-border Trade ERP",
  "全局": "General",
  "业务": "Operations",
  "主数据": "Master Data",
  "财务": "Finance",
  "本公司管理": "Company Admin",
  "总览": "Overview",
  "订单链路反查": "Order Trace",
  "销售订单": "Sales Orders",
  "采购订单": "Purchase Orders",
  "收发货管理": "Shipments",
  "装箱单": "Packing Lists",
  "库存台账": "Inventory",
  "产品库": "Products",
  "供应商库": "Suppliers",
  "客户库": "Customers",
  "货代库": "Forwarders",
  "收付款管理": "Receipts & Payments",
  "费用申请": "Expense Requests",
  "退款申请": "Refund Requests",
  "发票与 PO": "Invoices & POs",
  "财务报表": "Financial Reports",
  "用户管理": "Users",
  "系统设置": "Settings",
  "外部平台": "External Platforms",
  "浅色": "Light",
  "暗色": "Dark",
  "跟随系统": "Follow system",
  "日": "☀",
  "夜": "☾",
  "退出": "Log out",
  "平台": "Platform",
  "平台超管": "Platform Admin",
  "公司管理": "Companies",
  "平台审计": "Platform Audit",
  "wms-erp · 平台控制台": "wms-erp · Platform Console",
  "wms-erp · 平台超管": "wms-erp · Platform Admin",
  "平台层只放跨公司的视图。": "The platform area only shows cross-company views.",
  "单公司业务请以租户身份登录该公司。": "For a single company's business, log in to that company.",
  // ── 登录 ──
  "公司": "Company",
  "选择你的公司": "Select your company",
  "账号": "Username",
  "密码": "Password",
  "超管账号": "Admin username",
  "登 录": "Log in",
  "登录失败": "Login failed",
  "请填公司 / 账号 / 密码": "Please fill in company / username / password",
  "库里还没有任何公司。": "There are no companies yet.",
  "请先用平台超管账号建第一家。": "Create the first one with a platform admin account.",
  "去 /platform-login": "Go to /platform-login",
  "平台超管请去": "Platform admins go to",
  "公司账号请去": "Company accounts go to",
  // ── 通用 / 网络 ──
  "字段": "Field",
  "错误": "Error",
  "未知错误": "Unknown error",
  "浏览器拦截了弹窗 · 请允许本站弹出窗口后重试": "The browser blocked the pop-up · Allow pop-ups for this site and try again",
  "正在生成打印视图…": "Generating print view…",
  // ── 通用按钮 ──
  "操作": "Actions",
  "取消": "Cancel",
  "确认": "Confirm",
  "确定": "OK",
  "关闭": "Close",
  "刷新": "Refresh",
  "保存": "Save",
  "编辑": "Edit",
  "删除": "Delete",
  "详情": "Details",
  "提交": "Submit",
  "通过": "Approve",
  "驳回": "Reject",
  "作废": "Void",
  "归档": "Archive",
  "↩ 恢复": "↩ Restore",
  "启用": "Enable",
  "停用": "Disable",
  "暂停": "Pause",
  "打印": "Print",
  "导出 Excel": "Export Excel",
  "查询": "Search",
  "搜索": "Search",
  "重置": "Reset",
  "新建": "New",
  "添加": "Add",
  "上传": "Upload",
  "下载": "Download",
  "复制": "Copy",
  "返回": "Back",
  "+ 加一行": "+ Add row",
  "保存(draft)": "Save (draft)",
  // ── 通用反馈 ──
  "已保存": "Saved",
  "已创建": "Created",
  "已更新": "Updated",
  "已删除": "Deleted",
  "已切换": "Switched",
  "已转移": "Status updated",
  "没有改动": "No changes",
  "加载中…": "Loading…",
  "暂无数据": "No data",
  // ── 通用状态 ──
  "状态": "Status",
  "全部状态": "All statuses",
  "草稿": "Draft",
  "已提交": "Submitted",
  "已审批": "Approved",
  "已驳回": "Rejected",
  "已付款": "Paid",
  "已取消": "Cancelled",
  "已作废": "Voided",
  "已归档": "Archived",
  "已启用": "Enabled",
  "已停用": "Disabled",
  "启用中": "Active",
  "异常": "Exception",
  "默认": "Default",
  // 同一个中文、不同场景(见 i18n/index.ts「@@场景」)
  "启用@@状态": "Active",
  "停用@@状态": "Disabled",
  "暂停@@状态": "Paused",
  "归档@@状态": "Archived",
  "启用@@开关": "Enabled",
  "账号@@列表": "Accounts",
  "账号@@银行": "Account No.",
  "调整@@按钮": "Adjust",
  // ── 通用字段 ──
  "备注": "Notes",
  "类型": "Type",
  "来源": "Source",
  "来源类型": "Source type",
  "名称": "Name",
  "编号": "Code",
  "单号": "No.",
  "分类": "Category",
  "金额": "Amount",
  "币": "Cur.",
  "币种": "Currency",
  "单价": "Unit price",
  "数量": "Qty",
  "单位": "Unit",
  "小计": "Subtotal",
  "净额": "Net",
  "税率": "Tax rate",
  "税号": "Tax ID",
  "成本": "Cost",
  "时间": "Time",
  "创建时间": "Created at",
  "创建人": "Created by",
  "提交人": "Submitted by",
  "提交时间": "Submitted at",
  "审批人": "Approver",
  "操作人": "Operator",
  "明细": "Lines",
  "明细行": "Line items",
  "显示名": "Display name",
  "邮箱": "Email",
  "角色": "Role",
  "国家": "Country",
  "渠道": "Channel",
  "供应商": "Supplier",
  "客户": "Customer",
  "货代": "Forwarder",
  "产品": "Product",
  "产品编号": "Product code",
  "收款方": "Payee",
  "付款条款": "Payment terms",
  "收货地址": "Shipping address",
  "生效起": "Effective from",
  "重量(g)": "Weight (g)",
  "销售单": "Sales Order",
  "采购单": "Purchase Order",
  "收款": "Receipt",
  "付款": "Payment",
  "退款": "Refund",
  "选供应商": "Select supplier",
  "选客户": "Select customer",
  // 2026-09-24 修改密码 / 记住密码
  "修改密码": "Change Password",
  "退出登录": "Log Out",
  "旧密码": "Current Password",
  "确认新密码": "Confirm New Password",
  "至少 8 位": "At least 8 characters",
  "确认修改": "Change",
  "请填旧密码和新密码": "Enter your current and new password",
  "新密码至少 {n} 位": "The new password must be at least {n} characters",
  "两次输入的新密码不一样": "The two new passwords do not match",
  "密码已修改 · 下次登录用新密码": "Password changed · Use the new password next time you log in",
  "记住密码": "Remember password",
  "存在本机浏览器 · 公用电脑别勾": "Saved in this browser · not on shared computers",
  // 2026-10-19 表头右键冻结列
  "冻结到「{col}」(这列和左边的列不随滚动)": "Freeze through “{col}” (this and the columns to its left stay put when scrolling)",
  "取消冻结「{col}」": "Unfreeze “{col}”",
  "只冻结「{col}」(挪到最左边,其他列照常滚动)": "Freeze only “{col}” (moves to the far left; other columns scroll)",
  "取消全部冻结": "Unfreeze all columns",
  // 2026-10-19 手机适配
  "菜单": "Menu",
  "开始日期": "Start date",
  "结束日期": "End date",
  "搜索「{col}」这一列": "Search the \"{col}\" column",
  "搜索「{col}」这一列(只筛本页)": "Search the \"{col}\" column (this page only)",
  "输入要找的内容 · 回车确定 · Esc 清除": "Type to search · Enter to keep · Esc to clear",
  "清除搜索": "Clear search",
  "「{col}」含「{q}」· 本页 {n}/{m} 行": "\"{col}\" contains \"{q}\" · {n}/{m} rows on this page",
  "本页没有「{col}」含「{q}」的行": "No rows on this page where \"{col}\" contains \"{q}\"",
  "正在全部数据里查「{col}」含「{q}」…": "Searching all data for \"{col}\" containing \"{q}\"…",
  "全部数据里「{col}」含「{q}」": "All data where \"{col}\" contains \"{q}\"",
  "搜索「{col}」这一列(查全部数据)": "Search the \"{col}\" column (all data)",
  "输入要找的内容 · 回车查 · Esc 清除": "Type to search · Enter to search · Esc to clear",
} as Record<string, string>;
